<template>
  <v-container class="pa-2">
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center">
          <v-progress-circular indeterminate color="white" size="40" class="mb-4" />
          <span>Aguarde...</span>
        </v-card-text>
      </v-card>
    </v-dialog>
    <template v-if="usuario && usuario.nome">
      <v-card class="mt-5 mx-auto pa-3" style="max-width: 700px">
        <v-card-header class="d-flex align-center pa-4" style="border-radius: 6px; background-color: #f1e6e4">
          <v-icon color="blue" class="mr-2">mdi-account</v-icon>
          <span class="text-h6">Dados Pessoais</span>
        </v-card-header>

        <small>Nome</small>
        <v-text-field outlined readonly v-model="usuario.nome"></v-text-field>
        <small>Telefone</small>
        <v-text-field outlined v-model="usuario.fone"></v-text-field>
        <small>E-mail</small>
        <v-text-field
          outlined
          v-model="usuario.email"
          prepend-inner-icon="mdi-floppy"
          @click:prepend-inner="alterarEmail"
        ></v-text-field>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import ServidorServices from "@/services/rh/ServidorServices";
import CredenciamentoServices from "@/services/acesso/CredenciamentoServices";
import filtros from "@/libs/filters";
import { mapGetters } from "vuex";

export default {
  name: "DadosPessoais",
  data: () => ({
    user: {
      pkpessoa: "",
      nome: "",
      data_nasc: "",
      cpf: "",
      rg: "",
      pisPasep: "",
      fklocalizacao: "",
      numero: "",
      complemento: "",
      tipogeo: "",
      geodoc: "",
      latitude: "",
      longitude: "",
      contato: [
        {
          fone: "",
          email: "",
          contato: "",
        },
      ],
      proximidade: "",
      email: "",
      fone: "",
      sexo: "",
    },
    loading: false,
  }),
  components: {},
  filters: filtros,
  computed: {
    ...mapGetters({
      usuario: "storeServidor/getServidor",
    }),
    userLogado() {
      return this.$store.getters["config/getUsuarioLogado"] || this.user;
    },
  },
  methods: {
    async loadDados() {
      this.loading = true;
      await ServidorServices.getServidor({ pkpessoa: this.userLogado.pkpessoa });
      this.loading = false;
    },
    async alterarEmail() {
      this.loading = true;
      await CredenciamentoServices.alterarEmail({ email: this.usuario.email, cpf: this.usuario.cpf });
      await ServidorServices.getServidor({ pkpessoa: this.userLogado.pkpessoa });
      this.loading = false;
    },
  },
  mounted() {
    if (!this.usuario || !this.usuario.nome) {
      this.$router.push({ name: "homeMain" });
      return;
    }
    // ...se quiser carregar dados, pode chamar loadDados aqui...
  },
};
</script>
